<template>
  <div  v-loading="loading" style="margin:20px 30px;">
    <div class="notice-header" style="text-align: center;padding: 18px 0">
        <h2 class="title-A">{{ project.projectname }}</h2>
        <div class="line-A" style="color: #000;font-size: 18px;">项目评比表</div>
        <div class="line-A"></div>
    </div>
    <div class="view-container">
      <div class="view-box">
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">项目编号</div>
            <div class="view-value">{{project.projectcode}}</div>
          </div>
          <div class="view-field">
            <div class="view-label">平台编号</div>
            <div class="view-value">{{project.projectno}}</div>
          </div>
          <div class="view-field">
            <div class="view-label">采购人</div>
            <div class="view-value">{{project.pcomfullname}}</div>
          </div>
        </div>
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">项目名称</div>
            <div class="view-content">{{project.projectname}}</div>
          </div>
        </div>
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">项目初审</div>
            <div class="view-value">{{+project.projectisqcheck === 1 ? '需要' : '不需要'}}</div>
          </div>
          <div class="view-field">
            <div class="view-label">评审方法</div>
            <div class="view-con">{{project.prsflgdesc}}——{{project.projectdoneflgdesc}}<span v-if="project.prsflg !== '2' && project.prsflg !== '6'">——{{project.projectpricecomputebasisdesc}}</span></div>
          </div>
        </div>
      </div>
    </div>
    <div class="split-line"></div>
    <el-tabs v-model="activeName" type="card" :before-leave="leaveTab">
      <el-tab-pane :label="+project.projectqcheckflg ===1 ? '项目初审（已审）':'项目初审（未审）'" name="sc"
                   v-if="+project.projectisqcheck===1">
        <div v-if="+project.projectdoneflg === 3">
          <div v-if="+project.projectqcheckflg ===1">
            <pqces-form-check-sum-index :activeName="activeName" :projectid="$route.query.projectid"></pqces-form-check-sum-index>
          </div>
          <div v-else class="view-alertmsg">评审人未初审</div>
        </div>
        <div v-else>
          <pqces-form :activeName="activeName" :projectid="$route.query.projectid" @change="pqcChange"></pqces-form>
        </div>
      </el-tab-pane>
      <el-tab-pane lazy :label="+project.projectstatus >= 30 ? '评分结果（已评）':'评分结果（未评）'" name="pfxm">
        <div v-if="+project.projectdoneflg === 3 || +project.projectdoneflg === 5">
          <div v-if="(+project.projectqcheckflg ===1 || +project.projectisqcheck!==1) && +project.projectstatus >= 30">
            评审会签文件:
            <span v-for="(i,index) in appends" :key="index" style="color:blue;cursor: pointer;">
              <span class="name" @click="downFile(i.appendurl)"><a :src="uploadAddr + i.appendurl">{{i.appendfilename}}</a>
                          </span>
            </span>
            <project-scoring-sum-index :activeName="activeName" :projectid="$route.query.projectid"></project-scoring-sum-index>
          </div>
          <div v-else class="view-alertmsg">评审人未评分</div>
        </div>
        <div v-else>
          <price-mark :project="project" :projectid="$route.query.projectid" :activeName="activeName"
                      @change="pricemarkChange"></price-mark>
        </div>
      </el-tab-pane>
      <el-tab-pane lazy label="评审人信息" name="zjxx" v-if="+project.projectdoneflg === 3 || +project.projectdoneflg === 5">
        <pexpert-list :project="project" :projectid="$route.query.projectid" :activeName="activeName"></pexpert-list>
      </el-tab-pane>
      <el-tab-pane lazy label="审核改分申请" name="shxg" v-if="+project.projectdoneflg === 3 || +project.projectdoneflg === 5">
        <project-review-apply :project="project" :projectid="$route.query.projectid" :activeName="activeName">
        </project-review-apply>
      </el-tab-pane>
      <el-tab-pane
        lazy
        label="履约分"
        name="lvf"
        v-if="+project.projectdoneflg === 5"
      >
      <projectlyScore   
          :project="project"
          :projectid="$route.query.projectid"
          :activeName="activeName">
      </projectlyScore>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
  import request from '@/utils/request'
  import PqcesForm from '../jjgl/pqcesForm'
  import PqcesFormCheckSumIndex from '../jjgl/pqcesFormCheckSumIndex'
  import projectScoringSumIndex from '../jjgl/projectScoringSumIndex'
  import PriceMarkHandEdit from '../jjgl/priceMarkHandEdit'
  import projectReviewApply from '../jjgl/projectReviewApply'
  import pexpertList from '../jjgl/pexpertList'
  import projectlyScore from '../jjgl/projectlyScore'
  import PriceMark from './priceMarkFile'
  import utils from '../../assets/js/utils'
  import dayjs from 'dayjs'
  import common from '@/mixin/common'

  export default {
    name: 'projectReviewGcTabFile',
    mixins: [common],
    data () {
      return {
        activeName: 'sc',
        appends:[],
        project: {},
        loading:false
      }
    },
    async mounted () {
      await this.getModel()
      await this.getFile()
    },
    computed: {
      uploadAddr () {
        return this.$store.getters.uploadAddr
      }
    },
    watch: {},
    components: {PqcesForm, PriceMark, PqcesFormCheckSumIndex, projectScoringSumIndex,
    PriceMarkHandEdit,projectReviewApply,pexpertList, projectlyScore},
    methods: {
      pqcChange () {
        this.project.projectqcheckflg = 1
      },
      pricemarkChange () {
        this.project.projectstatus = 30
      },
      leaveTab (activeName, oldActiveName) {
        if (+this.project.projectdoneflg !== 3 && activeName === 'pfxm' && +this.project.projectisqcheck === 1 && +this.project.projectqcheckflg !== 1) {
          return new Promise((resolve, reject) => {
            this.$message.warning('请先资格性审查，再进行价格评分！')
          })
        }
      },
      async getFile(){
          this.loading = true
          this.appends = await request({
              method: 'get',
              url: 'ywgl/append/getAppendListByFromId',
              params: {appendfromid:this.project.projectid,
              appendfromtype:24}
          })
          this.loading = false
      },
      async getModel () {
        this.loading = true
        this.project = {}
        let res = await request({
          method: 'get',
          url: '/xmgl/project/findProjectById',
          params: {projectid: this.$route.query.projectid}
        })
        this.project = res
        if (+this.project.projectisqcheck === 1) {
          this.activeName = 'sc'
        } else {
          this.activeName = 'pfxm'
        }
        this.loading = false
      }
    }
  }
</script>
<style lang="scss">
</style>
